// :: User Store
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

// :: State
const state = {
  openServicesAtWork: 0,
  openServicesAtWorkshop: 0,
  chartOptionsWorkshopPrevent: {
    chart: {
      type: "bar",
      height: 120
    },
    title: null,
    xAxis: {
      categories: ["Preventivo"],
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      min: 0,
      title: null,
      labels: {
        overflow: "justify"
      },
      max: 150
    },
    tooltip: {
      valueSuffix: " productos"
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },

    credits: {
      enabled: false
    },
    series: [
      {
        data: [0],
        color: "#0071BC"
      }
    ]
  },
  chartOptionsWorkshopCorrect: {
    chart: {
      type: "bar",
      height: 120
    },
    title: null,
    xAxis: {
      categories: ["Preventivo"],
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      min: 0,
      title: null,
      labels: {
        overflow: "justify"
      },
      max: 150
    },
    tooltip: {
      valueSuffix: " productos"
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },

    credits: {
      enabled: false
    },
    series: [
      {
        name: "Correctivo",
        data: [0],
        color: "#0071BC"
      }
    ]
  },
  chartOptionsWorkCorrect: {
    chart: {
      type: "bar",
      height: 120
    },
    title: null,
    xAxis: {
      categories: ["Preventivo"],
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      min: 0,
      title: null,
      labels: {
        overflow: "justify"
      },
      max: 150
    },
    tooltip: {
      valueSuffix: " productos"
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },

    credits: {
      enabled: false
    },
    series: [
      {
        name: "Correctivo",
        data: [0],
        color: "#0071BC"
      }
    ]
  },
  chartOptionsWorkPrevent: {
    chart: {
      type: "bar",
      height: 120
    },
    title: null,
    xAxis: {
      categories: ["Preventivo"],
      title: {
        text: null
      },
      labels: {
        enabled: false
      }
    },
    yAxis: {
      min: 0,
      title: null,
      labels: {
        overflow: "justify"
      },
      max: 150
    },
    tooltip: {
      valueSuffix: " productos"
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true
        }
      }
    },

    credits: {
      enabled: false
    },
    series: [
      {
        name: "Correctivo",
        data: [0],
        color: "#0071BC"
      }
    ]
  },

  averagePreventiveWork: 0,
  averageCorrectiveWork: 0,
  averagePreventiveWorkshop: 0,
  averageCorrectiveWorkshop: 0,

  higherThanTwentyCorrect: 0,
  lowerThanTwentyCorrect: 0,
  higherThanOnePrevent: 0,
  lowerThanOnePrevent: 0,

  higherThanOnePreventField: 0,
  lowerThanOnePreventField: 0,
  higherThanOneCorrectField: 0,
  lowerThanOneCorrectField: 0
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
